SupportOrderListElementViewTemplate = require('../../../order_list_element_view.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $
SupportUtilsHelper = require('../../helpers/utils')

class SupportOrderView extends Backbone.View
  tagName: 'tr'
  className: 'orderTableRow'

  initialize: () ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportOrderListElementViewTemplate

  renderSingleItem: (order) ->
    data = @toHash(order)
    @$el.html toHtml(@template, data, @I18nScope)
    @$el.attr('key', data.id)
    @$el.attr('dateStr', data.purchasedAt)
    data

  renderEmptyTemplate: () ->
    data =
      showMultipleColumns: true
      hasData: false
    toHtml(@template, data, @I18nScope)

  replaceEmptyTemplateWithOrderTemplate: (emptyTd, order) ->
    data = @toHash(order)
    data.showMultipleColumns = true
    data.hasData = true
    emptyTd.replaceWith(toHtml(@template, data, @I18nScope))

  renderMultipleItems: (orders) ->
    _.each(orders, (order) =>
      if order
        data = @toHash(order)
        data.showMultipleColumns = true
        data.hasData = true
        @$el.append toHtml(@template, data, @I18nScope)
    )

  toHash: (order) ->
    data = switch order.DEAL_TYPE
      when 'GETAWAYS_TONIGHT' then @reservationHash(order)
      when 'GETAWAYS_MARKET_RATE' then @reservationHash(order)
      when 'GETAWAYS_BOOKING' then @getawaysBookingHash(order)
      else @orderHash(order)
    data

  orderHash: (order) ->
    quantity = order.quantity
    unless quantity?
      quantity = SupportUtilsHelper.findGrouponQuantity(order.groupons)
    data =
      id: order.id
      imageUrl: order.deal?.smallImageUrl || order.deal?.sidebarImageUrl || order.deal?.mediumImageUrl
      merchant: order.merchant?.name
      purchasedAt: order.purchasedAtshortDatetimeStr
      qty: quantity
      title: order.deal?.title

    return data

  getawaysBookingHash: (order) ->
    reservationSource = SupportUtilsHelper.getReservationSource(order)
    data =
      id: order.id
      imageUrl     : order.deal?.sidebarImageUrl || order.deal?.mediumImageUrl || order.deal?.smallImageUrl
      merchant     : reservationSource?.hotelName
      purchasedAt  : order.purchasedAtshortDatetimeStr
      title        : reservationSource?.roomNameHtml
      checkInDate  : reservationSource?.formattedCheckInShortDate
      checkOutDate : reservationSource?.formattedCheckOutShortDate
      showReservatioinDates: true
    return data

  reservationHash: (order) ->
    reservationSource = SupportUtilsHelper.getReservationSource(order)
    data =
      id: order.id
      imageUrl     : order.imageUrl
      merchant     : reservationSource?.hotelName
      purchasedAt  : order.purchasedAtshortDatetimeStr
      title        : reservationSource?.roomNameHtml
      checkInDate  : reservationSource?.formattedCheckInDate
      checkOutDate : reservationSource?.formattedCheckOutDate
      showReservatioinDates: true
    return data

module.exports = SupportOrderView
